/**
 * Translation keys for the /ambassadors page (Ahead Ambassador Program —
 * creator/influencer recruitment).
 *
 * All strings live in the `ambassadors` namespace in messages/{locale}.json.
 * Keys are author-defined (not Framer XLIFF) since this page has no Framer
 * predecessor.
 */
export const ambassadorsKeys = {
  // Section 1 — Hero
  heroLabel: "heroLabel",
  heroHeading: "heroHeading",
  heroSubtitleLead: "heroSubtitleLead",
  heroSubtitleEmphasis: "heroSubtitleEmphasis",
  heroCta: "heroCta",
  heroSecondaryCta: "heroSecondaryCta",
  // Hero floating-tile copy (decorative example "action plan" tiles
  // overlaid on the cyclist photo).
  tileCalciumTitle: "tileCalciumTitle",
  tileCalciumDesc: "tileCalciumDesc",
  tilePotassiumTitle: "tilePotassiumTitle",
  tilePotassiumDesc: "tilePotassiumDesc",
  tileExerciseTitle: "tileExerciseTitle",
  tileExerciseDesc: "tileExerciseDesc",
  tileBioAgeLabel: "tileBioAgeLabel",
  tileBioAgeEmphasis: "tileBioAgeEmphasis",
  tileBiomarkersLabel: "tileBiomarkersLabel",
  // Membership-benefits grid (Section 4) heading/eyebrow overrides —
  // the shared IncludedFigmaGrid takes these as props on /ambassadors.
  membershipEyebrow: "membershipEyebrow",
  membershipHeading: "membershipHeading",

  // Section 2 — The Ahead Ambassador profile
  profileTag: "profileTag",
  profileTrack1: "profileTrack1",
  profileTrack2: "profileTrack2",
  profileTrack3: "profileTrack3",
  profileBody: "profileBody",
  profileTaglineLead: "profileTaglineLead",
  profileTaglineTrail: "profileTaglineTrail",
  profileCta: "profileCta",

  // Section 4 — Membership benefits grid CTA (the "Learn about
  // membership" outline button under the shared IncludedFigmaGrid).
  programGetCta: "programGetCta",

  // Section 5 — How it works
  stepsLabel: "stepsLabel",
  stepsHeading: "stepsHeading",
  stepsSubtitle: "stepsSubtitle",
  step1Title: "step1Title",
  step1Desc: "step1Desc",
  step2Title: "step2Title",
  step2Desc: "step2Desc",
  step3Title: "step3Title",
  step3Desc: "step3Desc",
  step4Title: "step4Title",
  step4Desc: "step4Desc",

  // Section 6 — Closing CTA
  ctaHeading: "ctaHeading",
  ctaSubtitle: "ctaSubtitle",
  ctaButton: "ctaButton",
  ctaSupport: "ctaSupport",

  // Section 7 — Testimonials (overrides for the shared TestimonialsSection)
  testimonialsHeading: "testimonialsHeading",
  testimonialsSubtitle: "testimonialsSubtitle",

  // Section 8 — FAQ (questions/answers are CMS-managed via the FAQ
  // collection, `pages` tag = "ambassadors"; only the heading is a UI string)
  faqHeading: "faqHeading",

  // /ambassadors/applied — thank-you page (post-form-submit redirect target)
  appliedHeading: "appliedHeading",
  appliedBody: "appliedBody",
  appliedBackToAmbassadors: "appliedBackToAmbassadors",
  appliedCheckOffering: "appliedCheckOffering",
} as const
